var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.25 14.1514L13.75 8.65137",
    stroke: "#67308F",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.084 5.901L10.5084 5.40966C11.3681 4.55013 12.534 4.0673 13.7496 4.06738C14.9652 4.06747 16.1311 4.55047 16.9906 5.41012C17.8501 6.26978 18.333 7.43567 18.3329 8.65132C18.3328 9.86697 17.8498 11.0328 16.9902 11.8923L16.5007 12.3177",
    stroke: "#67308F",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.9161 16.901L11.5522 17.3905C10.6825 18.2505 9.50879 18.7329 8.28569 18.7329C7.06259 18.7329 5.88883 18.2505 5.01915 17.3905C4.59047 16.9667 4.25015 16.462 4.01788 15.9057C3.78561 15.3494 3.66602 14.7525 3.66602 14.1497C3.66602 13.5468 3.78561 12.95 4.01788 12.3937C4.25015 11.8374 4.59047 11.3327 5.01915 10.9088L5.49948 10.4844",
    stroke: "#67308F",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.68f7a999aa817fb80c3247648fa43002.svg";
export { ForwardRef as ReactComponent };